// 1. 외부 패키지
import { atom } from "recoil";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import { AreaType } from "./map-filter";

// 4. 타입

interface Model {
	area_type: AreaType;
	popup: number;
}

const basic_detail_atom = atom<Model>({
	key: '@basic/detail-atom',
	default: {
		area_type: 'PY',
		popup: 0,
	},
});

export default basic_detail_atom;